import { Container, Reveal, Section, SectionHead } from '@nexa/ui';
import { useCopy } from '@/core/i18n';

/**
 * `#connectors` — `template.html:974`.
 *
 * Section này KHÔNG nằm trong `SPY_IDS` của `Header` (nav không theo dõi nó) nhưng VẪN giữ
 * `id="connectors"` theo thiết kế — nó vẫn là đích neo hợp lệ.
 *
 * Nhịp dọc dùng bậc `--spacing-section-sm` (46.7 → 80px): thiết kế đo 80px ở `:974`, mà `Section`
 * chỉ có hai bậc 96 và 104.
 *
 * Bản đầu viết `py-20!` = 80px CỐ ĐỊNH, và nó sai ở mobile: `--spacing-section` là clamp 56→96,
 * nên 80 cố định cho ra 80 < 96 ở desktop (đúng ý "chặt hơn hàng xóm") nhưng 80 > 56 ở 360px —
 * lật ngược đúng cái quan hệ cần giữ. Bậc mới co cùng hệ số 80/96 nên đúng ở MỌI khổ.
 *
 * Dấu `!` bắt buộc: `cn()` chỉ nối chuỗi nên không có nó thì thắng thua phụ thuộc thứ tự Tailwind
 * xếp utility, chứ không phải thứ tự chuỗi. Cùng lý do với `py-0!` của hero.
 *
 * `SectionHead` KHÔNG truyền `maxWidth`: mặc định 60ch, nhưng cột trái ở 1440 chỉ rộng ~529px
 * (1240 trừ gap 64, chia theo 0.9/1.1) trong khi 60ch ở cỡ lead xấp xỉ 605px ⇒ cột hẹp hơn nên
 * ràng buộc kia không bao giờ chạm. Đo trước khi kết luận.
 *
 * Ô connector lấy số từ `template.html:982` — nền `surface`, viền `ink-100`. `reference.md` §3
 * ghi viền `ink-50` và không nhắc nền; đi theo mục đó là vẽ ô TÀNG HÌNH trên section nền `ink-50`.
 */
export function ConnectorsSection() {
  const copy = useCopy();

  return (
    <Section
      id="connectors"
      tone="muted"
      labelledBy="connectors-heading"
      cv
      // Mồi content-visibility khai theo bậc trong `packages/ui/src/motion.css`, không ở đây.
      className="py-section-sm! nx-cv-connectors"
    >
      <Container className="grid items-center gap-16 xl:grid-cols-[0.9fr_1.1fr]">
        <Reveal>
          <SectionHead
            id="connectors-heading"
            eyebrow={copy.connectors.eyebrow}
            heading={copy.connectors.heading}
            lead={copy.connectors.lead}
          />
        </Reveal>

        <Reveal className="grid grid-cols-2 gap-3 md:grid-cols-4">
          {copy.connectors.tiles.map((tile) => (
            <div
              key={tile}
              className="grid h-[74px] place-items-center rounded-card-sm border border-ink-100 bg-surface text-body-sm font-semibold text-ink-700 transition [transition-duration:var(--duration-hover)] hover:border-brand-600 hover:text-brand-600"
            >
              {tile}
            </div>
          ))}
        </Reveal>
      </Container>
    </Section>
  );
}
